import React from 'react';
import { BsSearch } from 'react-icons/bs';

const DropdownIndicatorComponent = () => (
  <BsSearch size={20} style={{ fill: '#285FCB' }} />
);

export default DropdownIndicatorComponent;
